export type SkeletonRadius = 'sm' | 'md' | 'lg' | 'xl' | 'full';

export const SKELETON_DELAY_MS = 700;
export const SKELETON_FADE_MS = 600;
export const SKELETON_ROWS = [0, 1, 2, 3, 4] as const;

export function skeletonRows(count: number): readonly number[] {
  return Array.from({ length: count }, (_, i) => i);
}
